import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import {
  isPublicPath,
  loadTags,
  noticeSeen,
  setOptOut,
  tagsAllowed,
  trackPageView,
} from "../lib/adTags";

/**
 * Loads the ad and analytics tags on public pages and sends one page view per
 * route, plus a one-time notice that lets a visitor switch them off.
 *
 * Renders nothing in the signed-in app, and nothing at all where the tags are
 * not configured (local, preview, tests).
 */
export function AdTags() {
  const { pathname } = useLocation();
  const [showNotice, setShowNotice] = useState(false);

  useEffect(() => {
    if (loadTags(pathname)) trackPageView(pathname);
    setShowNotice(isPublicPath(pathname) && tagsAllowed() && !noticeSeen());
  }, [pathname]);

  if (!showNotice) return null;

  const choose = (optOut: boolean) => {
    setOptOut(optOut);
    setShowNotice(false);
    // Already-loaded tags stop sending at once; the page reload drops them.
    if (optOut) window.location.reload();
  };

  return (
    <div
      role="region"
      aria-label="Cookies"
      className="fixed inset-x-0 bottom-[calc(env(safe-area-inset-bottom)+16px)] z-40 flex justify-center px-5"
    >
      <div className="flex w-full max-w-[400px] flex-col gap-3 rounded-[var(--radius-card)] border border-border bg-surface p-3.5 shadow-lg">
        <p className="m-0 text-[13px] leading-[1.45] text-text">
          We use Meta, TikTok and Google cookies on these public pages to see which ads bring people
          to PrepAI. Never inside the app, and never with your name or email.{" "}
          <a href="/privacy" className="text-accent underline">
            Privacy policy
          </a>
        </p>
        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={() => choose(true)}
            className="rounded-[var(--radius-control)] border border-border px-4 py-2 text-[13px] font-semibold text-text"
          >
            Turn off
          </button>
          <button
            type="button"
            onClick={() => choose(false)}
            className="rounded-[var(--radius-control)] bg-accent px-4 py-2 text-[13px] font-semibold text-on-accent active:bg-accent-pressed"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
